var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full"},[_c('div',{staticClass:"event-chart overflow-hidden rounded-md shadow-lg"},[_c('apex-chart',{attrs:{"width":"100%","height":"100%","type":"bar","options":_vm.options,"series":_vm.series}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }